import { useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import { Numeric } from '@blade/ui-kit'
import { Trend } from '@root/entities/trend/model'
import { PnlUsdFormatted } from '@root/shared/core/format'
import { useOptionalAtom } from '@root/shared/lib'

import { EmptyCell, TextCell } from './favorite-table-common'

import type { PairModel } from '@root/entities/pair/atoms'

type FavoriteTablePnlProps = {
  pair: PairModel
}

export const FavoriteTablePnlCell: React.FC<FavoriteTablePnlProps> = ({
  pair,
}) => {
  const [position] = useAtom(pair.position)
  const pnlUsd = useOptionalAtom(position?.unrealizedPnlUsd)

  if (!pnlUsd || pnlUsd.pnlUsd.isZero()) {
    return <EmptyCell />
  }

  return (
    <Root data-trend={Trend.of(pnlUsd.pnlPercentage)}>
      <PnlUsdFormatted pnl={pnlUsd.pnlUsd} />
      <div>
        <Numeric value={pnlUsd.pnlPercentage} preset="percents" forceSign />%
      </div>
    </Root>
  )
}

const Root = styled(TextCell)``
